import { FloatingFormItem } from '@/components/_common';
import { Col, Input, Modal, ModalProps, Row, Typography } from 'antd';

interface Props extends ModalProps {
  open: boolean;
  onCancel: VoidFunction;
  onSubmit: () => void;
  loadingValidate: boolean;
  data?: {
    login: string;
    password: string;
  };
}

const InvoiceCreateAuthenticationModal = ({
  open,
  onCancel,
  onSubmit,
  loadingValidate,
  data,
}: Props) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      onOk={onSubmit}
      confirmLoading={loadingValidate}
      destroyOnClose
    >
      <Row>
        <Col span={24}>
          <Typography.Title level={4}>Autenticação prefeitura</Typography.Title>

          <Row gutter={[16, 16]}>
            <Col span={24} md={12}>
              <FloatingFormItem
                label="Login"
                name={'nfsLogin'}
                initialValue={data?.login}
              >
                <Input />
              </FloatingFormItem>
            </Col>

            <Col span={24} md={12}>
              <FloatingFormItem
                label="Senha"
                name={'nfsPassword'}
                initialValue={data?.password}
              >
                <Input />
              </FloatingFormItem>
            </Col>
          </Row>
        </Col>
      </Row>
    </Modal>
  );
};

export default InvoiceCreateAuthenticationModal;
